"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateHsnCodeSchema = exports.calculateTaxSchema = void 0;
const zod_1 = require("zod");
exports.calculateTaxSchema = zod_1.z.object({
    amount: zod_1.z.number().int(),
    gstPercent: zod_1.z.number().min(0).max(100).optional(),
    cessPercent: zod_1.z.number().min(0).max(100).optional(),
    isInclusive: zod_1.z.boolean().optional(),
});
exports.validateHsnCodeSchema = zod_1.z.object({
    hsnCode: zod_1.z.string().min(1),
});
//# sourceMappingURL=tax-calculation.schema.js.map